import React from "react";
import ReactDOM from "react-dom/client";
import App from "./components/App";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-datepicker/dist/react-datepicker.css";
import "./index.css";
import { I18nextProvider } from "react-i18next";
import i18next from "i18next";
import { Auth0Provider } from "@auth0/auth0-react";
import ReactTimeAgo from "react-time-ago";
import TimeAgo from "javascript-time-ago";

import es from "javascript-time-ago/locale/es";
import ru from "javascript-time-ago/locale/ru";
import "@formatjs/intl-relativetimeformat/polyfill";
import "@formatjs/intl-relativetimeformat/locale-data/es"; // Importa todos los locales que necesites (por ejemplo, 'es' para español)

import footer_es from "./translations/es/footer.json";
import footer_en from "./translations/en/footer.json";
TimeAgo.addDefaultLocale(es);
TimeAgo.addLocale(ru);
const domain = process.env.REACT_APP_AUTH0_DOMAIN;
const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
const resizeObserverWarning =
  "ResizeObserver loop completed with undelivered notifications";

const filterWarning = (...args) => {
  if (args[0] && args[0].includes(resizeObserverWarning)) {
    return; // Bloquea la advertencia
  }
  // Llamada a la función original si no es la advertencia que buscamos
  originalConsoleWarn(...args);
};

// 1. Interceptar console.error
const originalConsoleError = console.error;
console.error = (...args) => {
  const msg = typeof args[0] === "string" ? args[0] : "";
  if (msg.includes(resizeObserverWarning)) {
    return;
  }
  originalConsoleError(...args);
};

// 2. Interceptar console.warn (donde a veces se registra)
const originalConsoleWarn = console.warn;
console.warn = (...args) => {
  const msg = typeof args[0] === "string" ? args[0] : "";
  if (msg.includes(resizeObserverWarning)) {
    return;
  }
  originalConsoleWarn(...args);
};

i18next.init({
  interpolation: { escapeValue: false },
  lng: localStorage.getItem("lng") || "es",
  resources: {
    es: {
      footer: footer_es,
    },
    us: {
      footer: footer_en,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        redirect_uri: `${process.env.REACT_APP_LOGIN_URL}`,
      }}
    >
      <I18nextProvider i18n={i18next}>
        <App />
      </I18nextProvider>
    </Auth0Provider>
  </React.StrictMode>
);
